// RegisterModal.js
import React, {useState} from 'react';
import {GoogleLogin} from '@react-oauth/google';
import './RegisterModal.css';

export default function RegisterModal({
                                          visible,
                                          onClose,
                                          onGoogleSuccess,
                                      }) {
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    if (!visible) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        const res = await fetch('https://5x5gu5f6ojvf4qvvmfg7wmysfu0vfdhq.lambda-url.eu-west-2.on.aws/auth/register', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                action: 'register',
                firstname: firstname,
                lastname: lastname,
                email: email,
                password: password
            })
        });

        if (!res.ok) {
            throw new Error(`Error: ${res.status}`);
        }
        const data = await res.json();
        console.log(data);

        // Очищення полів
        setFirstname('');
        setLastname('');
        setEmail('');
        setPassword('');

        // Запис кукі
        document.cookie = `userData=${JSON.stringify({
            firstname: data.firstname, 
            email: data.email,
            token: data.token
        })}; path=/`;

        // Закриття модалки
        window.location.reload();
    };

    return (
        <div className="reg-modal-backdrop">
            <div className="reg-modal-content">
                <button className="reg-close-btn" onClick={onClose}>
                    &times;
                </button>
                <h2 className="reg-title">Register</h2>

                <form className="reg-form" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="First Name"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        className="reg-input"
                        required
                    />
                    <input
                        type="text"
                        placeholder="Last Name"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        className="reg-input"
                        required
                    />
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="reg-input"
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="reg-input"
                        required
                    />
                    <button type="submit" className="reg-submit-btn">
                        Register
                    </button>
                    <div className="google-section">
                        <GoogleLogin
                            onSuccess={(credentialResponse) => {
                                console.log('Google ID token:', credentialResponse.credential);
                                onGoogleSuccess(credentialResponse.credential);
                            }}
                            onError={() => {
                                console.error('Google Login Failed');
                            }}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
}
